import ApiService from './_api.service'
import TokenService, { UserStorageService } from './storage.service'

const AuthService = {
    me: function () {
        return ApiService.get(process.env.VUE_APP_API_USERS_URL + 'me/')
    },

    /**
     * Login the user and store the access token to TokenService.
     *
     * @returns access_token
     * @throws AuthenticationError
     **/
    login: async function (username, password) {
        let formData = new FormData()
        formData.set('username', username)
        formData.set('password', password)

        const requestData = {
            method: 'post',
            url: process.env.VUE_APP_API_AUTH_SIGNIN_URL,
            data: formData
        }

        const response = await ApiService.customRequest(requestData)

        TokenService.saveToken(response.data.access)
        TokenService.saveRefreshToken(response.data.refresh)
        ApiService.setHeader()
        ApiService.mount401Interceptor()

        return response.data.access
    },

    /**
     * Refresh the access token.
     **/
    refreshToken: async function () {
        const refreshToken = TokenService.getRefreshToken()

        let formData = new FormData()
        formData.set('refresh', refreshToken)

        const requestData = {
            method: 'post',
            url: process.env.VUE_APP_API_AUTH_REFRESH_URL,
            data: formData
        }

        const response = await ApiService.customRequest(requestData)

        TokenService.saveToken(response.data.access)
        // Update the header in ApiService
        ApiService.setHeader()

        return response.data.access
    },

    accessToken: async function (token) {
        let formData = new FormData()
        formData.set('access_token', token)

        const requestData = {
            method: 'post',
            url: process.env.VUE_APP_API_AUTH_ACCESS_TOKEN_URL,
            data: formData
        }

        const response = await ApiService.customRequest(requestData)

        TokenService.saveToken(response.data.access)
        TokenService.saveRefreshToken(response.data.refresh)
        UserStorageService.save(response.data.user)
        ApiService.setHeader()
        ApiService.mount401Interceptor()

        return response.data
    },

    lock() {
        TokenService.saveToken('Locked!')
        TokenService.saveRefreshToken('Locked!')
        ApiService.setHeader()
    },

    /**
     * Logout the current user by removing the token from storage.
     *
     * Will also remove `Authorization Bearer <token>` header from future requests.
     **/
    logout() {
        // Remove the token and remove Authorization header from Api Service as well
        TokenService.removeToken()
        TokenService.removeRefreshToken()
        ApiService.removeHeader()

        // NOTE: Again, we'll cover the 401 Interceptor a bit later.
        ApiService.unmount401Interceptor()
    }
}

export default AuthService
export { AuthService }
